import CommonUtils from '@/common-utils';

export default [
  {
    path: '/',
    component: () => CommonUtils.isNewCustomer() ? import(/* webpackChunkName: "others" */  '../views/Splash.vue') : import(/* webpackChunkName: "layout" */ '../views/layouts/LayoutMain.vue'),
    children: [
      {
        path: '/',  // 메인
        name: 'Main',
        props: true,
        title: 'Main',
        meta: { keepAlive: true },
        component: () => import(/* webpackChunkName: "main" */ '../views/biz/main/Main.vue'),
      },
      {
        path: '/main/:layoutCd',  // 메인 레이아웃(미리보기)
        name: 'MainLayout',
        props: true,
        meta: { keepAlive: true },
        component: () => import(/* webpackChunkName: "main" */ '../views/biz/main/Main.vue'),
      },
      {
        path: '/main/menu/:initMenuIdx',  // 메인 메뉴 바로가기(SEO)
        name: 'MainMenu',
        props: true,
        meta: { keepAlive: true },
        component: () => import(/* webpackChunkName: "main" */ '../views/biz/main/Main.vue'),
      },
      {
        path: '/product/cs/delivery', // 배송 정보
        name: 'ProductDeliveryInfo1',
        props: true,
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/product/ProductDeliveryInfo1.vue'),
      },
      {
        path: '/product/cs/:productType', // 배송/교환/반품 정보
        name: 'ProductDeliveryInfo2',
        props: true,
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/product/ProductDeliveryInfo2.vue'),
      },
      {
        path: '/product/:productCd', // 상품 상세
        name: 'Product',
        props: true,
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/product/Product.vue'),
      },
      {
        path: '/product/:productCd/coupons', // 상품 쿠폰 목록
        name: 'ProductCoupons',
        meta: {
          auth: true
        },
        props: true,
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/product/ProductCoupons.vue'),
      },
      {
        path: '/order/cart', // 장바구니
        name: 'OrderCart',
        meta: { auth: true },
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/order/Cart.vue'),
      },
      {
        path: '/order/payment/:orderCd', // 주문결제
        name: 'OrderPayment',
        props: true,
        meta: { auth: true, keepAlive: true },
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/order/OrderPayment.vue'),
      },
      {
        path: '/order/:orderCd/product-coupons', // 주문 상품 쿠폰 목록
        name: 'MyProductCoupons',
        props: true,
        meta: { auth: true },
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/order/MyProductCoupons.vue'),
      },
      {
        path: '/order/payment-complete/:orderCd?', // 결제 완료
        name: 'PaymentComplete',
        props: true,
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/order/PaymentComplete.vue'),
      },
      {
        path: '/menu/categories', // 메뉴>카테고리
        name: 'MenuCategories',
        meta: { keepAlive: true },
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/menu/Categories.vue'),
      },
      {
        path: '/menu/category/:cateCd/products', // 메뉴>카테고리>상품
        name: 'MenuCategoryProducts',
        props: true,
        meta: { keepAlive: true },
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/menu/CategoryProducts.vue'),
      },
      {
        path: '/menu/brands', // 메뉴>브랜드
        name: 'MenuBrands',
        meta: { keepAlive: true },
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/menu/Brands.vue'),
      },
      {
        path: '/menu/brand/:brandCd/products', // 메뉴>브랜드>상품
        name: 'MenuBrandProducts',
        props: true,
        meta: { keepAlive: true },
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/menu/BrandProducts.vue'),
      },
      {
        path: '/coupon/:couponCd/products', // 쿠폰함>적용대상보기>상품
        name: 'CouponProducts',
        props: true,
        meta: { keepAlive: true },
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/menu/CouponProducts.vue'),
      },
      //////////////////////////////////////
      // URL 이 RESTFUL 하지 않아서 변경. (검색 때문에 old URL 안지움) TODO 위 4 router 지움
      //////////////////////////////////////
      {
        path: '/categories', // 메뉴>카테고리
        name: 'Categories',
        meta: { keepAlive: true },
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/menu/Categories.vue'),
      },
      {
        path: '/category/:cateCd', // 메뉴>카테고리>상품
        name: 'CategoryProducts',
        props: true,
        meta: { keepAlive: true },
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/menu/CategoryProducts.vue'),
      },
      {
        path: '/brands', // 메뉴>브랜드
        name: 'Brands',
        meta: { keepAlive: true },
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/menu/Brands.vue'),
      },
      {
        path: '/brand/:brandCd', // 메뉴>브랜드>상품
        name: 'BrandProducts',
        props: true,
        meta: { keepAlive: true },
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/menu/BrandProducts.vue'),
      },
      ////////////////////////////////////
      {
        path: '/promotion/:layoutCd', // 프로모션
        name: 'Promotion',
        props: true,
        meta: { keepAlive: true },
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/main/Promotion.vue'),
      },
      {
        path: '/search', // 통합검색
        name: 'Search',
        meta: { keepAlive: true },
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/search/Search.vue'),
      },
      {
        path: '/search/products/:keyword?', // 통합검색결과 - 상품
        name: 'SearchProducts',
        meta: { keepAlive: true },
        props: true,
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/search/SearchProducts.vue'),
      },
      {
        path: '/search/reviews/:keyword?', // 통합검색결과 - 리뷰 
        name: 'SearchUgcs',
        meta: { keepAlive: true },
        props: true,
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/search/SearchProducts.vue'),
      },
      {
        path: '/search/feeds/:keyword?', // 통합검색결과 - 피드
        name: 'SearchFeeds',
        meta: { keepAlive: true },
        props: true,
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/search/SearchProducts.vue'),
      },
      {
        path: '/product/:productCd/qna', // 상품상세>문의
        name: 'Qna',
        props: true,
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/product/Qna.vue'),
      },
      {
        path: '/product/:productCd/qna-form', // 상품상세>문의등록
        name: 'QnaForm',
        props: true,
        meta: { auth: true },
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/product/QnaForm.vue'),
      },
      {
        path: '/mypage', // 마이페이지
        name: 'Mypage',
        meta: { auth: true },
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/mypage/Mypage.vue'),
      },
      // {
      //   path: '/mypage/inquiry-history', // 마이페이지>문의내역
      //   name: 'InquiryHistory',
      //   props: true,
      //   meta: {auth: true},
      //   component: () => import(/* webpackChunkName: "others" */  '../views/biz/mypage/InquiryHistory.vue'),
      // },
      {
        path: '/mypage/products', // 내상품 관리
        name: 'MyProducts',
        meta: { auth: true, keepAlive: true },
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/mypage/MyProducts.vue'),
      },
      {
        path: '/mypage/customer-center/faq', // 마이페이지>FAQ
        name: 'Faq',
        props: true,
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/mypage/Faq.vue'),
      },
      {
        path: '/mypage/customer-center/qna', // 마이페이지>나의문의내역
        name: 'MyQna',
        props: true,
        meta: { auth: true },
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/mypage/MyQna.vue'),
      },
      {
        path: '/mypage/profile', // 마이페이지>내정보관리
        name: 'MypageProfile',
        meta: { auth: true },
        component: () => import(/* webpackChunkName: "others" */  '../views/biz-kr/mypage/Profile.vue'),
      },
      {
        path: '/mypage/order/orders/:tab', // 마이페이지>주문&배송목록>전체보기
        name: 'OrderDeliveryInventory',
        props: true,
        meta: { auth: true },
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/mypage/OrderDeliveryInventory.vue'),
      },
      {
        path: '/mypage/order/tracking/:orderCd', // 마이페이지>주문상세>배송추적
        name: 'OrderDeliveryTracking',
        props: true,
        meta: { auth: true },
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/mypage/OrderDeliveryTracking.vue'),
      },
      {
        path: '/mypage/order/claim/invoice-number/form/:claimCd', // 마이페이지>주문상세(취소&반품)>운송장번호 입력
        name: 'InvoiceNumberForm',
        props: true,
        meta: { auth: true },
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/mypage/InvoiceNumberForm.vue'),
      },
      {
        path: '/mypage/order/claim', // 마이페이지>주문취소/반품목록>전체보기
        name: 'OrderClaimInventory',
        props: true,
        meta: { auth: true },
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/mypage/OrderClaimInventory.vue'),
      },
      {
        path: '/mypage/order/claim/:claimType/:orderCd/:claimCd?', // 마이페이지>클레임상세,폼
        name: 'OrderClaimDetail',
        props: true,
        meta: { auth: true },
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/order/OrderClaimForm.vue'),
      },
      {
        path: '/mypage/order/:orderCd', // 마이페이지>주문상세(주문&배송)
        name: 'OrderDetails',
        props: true,
        meta: { auth: true },
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/order/OrderDetail.vue'),
      },
      {
        path: '/mypage/address/change', // 마이페이지 > 주문상세 > 주소변경
        name: 'DeliveryAddressChange',
        props: true,
        meta: { auth: true},
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/order/DeliveryAddressChange.vue')
      },
      {
        path: '/mypage/confirm-purchase', // 마이페이지>구매확정
        name: 'ConfirmPurchase',
        props: true,
        meta: { auth: true },
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/mypage/ConfirmPurchase.vue'),
      },
      {
        path: '/mypage/point', // 마이페이지>포인트
        name: 'Point',
        meta: { auth: true },
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/mypage/Point.vue'),
      },
      {
        path: '/mypage/my-coupons', // 마이페이지>쿠폰함
        name: 'MyCoupons',
        meta: { auth: true },
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/mypage/MyCoupons.vue'),
      },
      {
        path: '/join/sns/complete/:openId', // SNS로그인>가입완료
        name: 'SnsJoinComplete',
        props: true,
        meta: { auth: true },
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/join/SnsJoinComplete.vue'),
      },
      {
        path: '/introduction', // 인트로(회사소개 진입 화면)
        name: 'Introduction',
        props: true,
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/introduction/Introduction.vue'),
      },
      {
        path: '/introduction/company', // 회사소개
        name: 'Company',
        props: true,
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/introduction/Company.vue'),
      },
      {
        path: '/introduction/terms', // 이용약관
        name: 'Terms',
        props: true,
        component: () => import(/* webpackChunkName: "others" */  '../views/biz/introduction/Terms.vue'),
      },
      {
        path: '/introduction/privacy-policy', // 개인정보보호
        name: 'PrivacyPolicy',
        props: true,
        component: () => import(/* webpackChunkName: "others" */  '../views/biz-kr/member/PrivacyPolicy.vue'),
      },
      {
        path: '/login/find-id', // 아이디 찾기
        name: 'FindId',
        component: () => import(/* webpackChunkName: "kr" */  '../views/biz-kr/login/FindId.vue'),
      },
      {
        path: '/login/find-id/result', // 아이디 찾기 결과
        name: 'FindIdResult',
        component: () => import(/* webpackChunkName: "kr" */  '../views/biz-kr/login/FindIdResult.vue'),
      },
      {
        path: '/login/find-password', // 비밀번호 찾기
        name: 'FindPassword',
        component: () => import(/* webpackChunkName: "kr" */  '../views/biz-kr/login/FindPassword.vue'),
      },

      {
        path: '/login/find-password/result', // 비밀번호 찾기 결과
        name: 'FindPasswordResult',
        component: () => import(/* webpackChunkName: "kr" */  '../views/biz/login/FindPasswordResult.vue'),
      },
      {
        path: '/member/link-sns', // SNS 계정 연동
        name: 'LinkSns',
        component: () => import(/* webpackChunkName: "kr" */  '../views/biz-kr/member/LinkSns.vue'),
      },
      {
        path: '/mypage/change-password', // 비밀번호 변경
        name: 'ChangePassword',
        meta: { auth: true },
        component: () => import(/* webpackChunkName: "kr" */  '../views/biz-kr/mypage/ChangePassword.vue'),
      },
      {
        path: '/mypage/link-sns', // SNS 연동
        name: 'MypageLinkSns',
        meta: { auth: true },
        component: () => import(/* webpackChunkName: "kr" */  '../views/biz-kr/mypage/LinkSns.vue'),
      },
      {
        path: '/mypage/member-info/confirm', // 회원 정보 비밀번호 확인
        name: 'MemberInfoConfirm',
        meta: { keepAlive: false, auth: true },
        beforeEnter: (to, from, next) => {
          if (from.name == 'MemberInfo') {
            history.back();
          } else {
            next();
          }
        },
        component: () => import(/* webpackChunkName: "kr" */  '../views/biz-kr/mypage/MemberInfoConfirm.vue'),
      },
      {
        path: '/mypage/real-name-form', // 실명인증폼
        name: 'RealNameForm',
        props: true,
        component: () => import(/* webpackChunkName: "kr" */  '../views/biz-kr/login/RealNameForm.vue'),
      },
      // 신규(김현진) --------------------------------------------
      {
        path: '/best-reviews/:ugcCd?', // 리뷰 목록(베스트리뷰)
        name: 'BestReviews',
        props: true,
        meta: { keepAlive: true },
        component: () => import(/* webpackChunkName: "kr" */  '../views/biz/review/BestReviews.vue'),
      },
      {
        path: '/review/product/:productCd', // 리뷰 목록(상품상세)
        name: 'ProductReviews',
        props: true,
        meta: { keepAlive: true },
        component: () => import(/* webpackChunkName: "kr" */  '../views/biz/product/ProductReviews.vue'),
      },
      {
        path: '/review/:reviewCd/modify', // 리뷰 작성
        name: 'ReviewModify',
        props: true,
        meta: { auth: true },
        component: () => import(/* webpackChunkName: "kr" */  '../views/biz/review/ReviewForm.vue'),
      },
      {
        path: '/review/new', // 리뷰 작성
        name: 'ReviewForm',
        props: true,
        meta: { auth: true },
        component: () => import(/* webpackChunkName: "kr" */  '../views/biz/review/ReviewForm.vue'),
      },
      {
        path: '/best-feeds/:ugcCd?', // 베스트 피드 목록
        name: 'BestFeeds',
        props: true,
        meta: { keepAlive: true },
        component: () => import(/* webpackChunkName: "kr" */  '../views/biz/feed/BestFeeds.vue'),
      },
      {
        path: '/feed/:ugcCd/modify', // 피드 수정
        name: 'FeedModify',
        props: true,
        meta: { auth: true },
        component: () => import(/* webpackChunkName: "kr" */  '../views/biz/feed/FeedForm.vue'),
      },
      {
        path: '/feed/new', // 피드 작성
        name: 'FeedForm',
        props: true,
        meta: { auth: true },
        component: () => import(/* webpackChunkName: "kr" */  '../views/biz/feed/FeedForm.vue'),
      },
      {
        path: '/talk/:ugcCd/modify', // 톡톡 수정
        name: 'TalkModify',
        props: true,
        meta: { auth: true },
        component: () => import(/* webpackChunkName: "kr" */  '../views/biz/talk/TalkForm.vue'),
      }, 
      {
        path: '/talk/new', // 톡톡 작성
        name: 'TalkForm',
        props: true,
        meta: { auth: true },
        component: () => import(/* webpackChunkName: "kr" */  '../views/biz/talk/TalkForm.vue'),
      },      
      {
        path: '/mypage/reviews/:tab', // 리뷰 목록(마이페이지)
        name: 'MypageReviews',
        props: true,
        meta: {
          auth: true
        },
        component: () => import(/* webpackChunkName: "kr" */  '../views/biz/mypage/MypageReviews.vue'),
      },
      {
        path: '/notices/:tab?', // 공지사항 목록
        name: 'Notices',
        props: true,
        component: () => import(/* webpackChunkName: "kr" */  '../views/biz/mypage/Notices.vue'),
      },
      {
        path: '/notice/:noticeCd', // 공지사항 목록
        name: 'Notice',
        props: true,
        component: () => import(/* webpackChunkName: "kr" */  '../views/biz/mypage/Notice.vue')
      },
      {
        path: '/mypage/member-info/real-name', // 마이페이지>프로파일>본인인증
        name: 'ProfileRealNameAuth',
        meta: { auth: true },
        props: true,
        component: () => import(/* webpackChunkName: "kr" */  '../views/biz-kr/mypage/ProfileRealNameAuth.vue')
      },
      {
        path: '/mypage/member-info/real-name-auth', // 본인인증 창
        name: 'RealNameAuth',
        props: true,
        component: () => import(/* webpackChunkName: "kr" */  '../components/RealNameAuth.vue')
      },
      {
        path: '/notification/notification', // 알림
        name: 'Notification',
        meta: { auth: true },
        props: true,
        component: () => import(/* webpackChunkName: "kr" */  '../views/biz/notification/Notification.vue'),
      },
      {
        path: '/image-viewer', // 이미지 뷰어
        name: 'ImageViewer',
        props: true,
        component: () => import(/* webpackChunkName: "kr" */  '../views/biz/common/ImageViewer.vue'),
      },
      {
        path: '/profile/profile-info', // 커뮤니티 > 프로파일 수정
        name: 'ProfileInfo',
        props: true,
        component: () => import(/* webpackChunkName: "kr" */  '../views/biz/community/ProfileInfo.vue'),
      },
      {
        path: '/profile/:targetMemCd', // 커뮤니티 > 프로파일
        name: 'Profile',
        props: true,
        meta: { keepAlive: true },        
        component: () => import(/* webpackChunkName: "kr" */  '../views/biz/community/Profile.vue'),
      },
      {
        path: '/reviews/:ugcCd?', // UGC컨텐츠 > 리뷰 목록
        name: 'Reviews',
        props: true,
        component: () => import(/* webpackChunkName: "kr" */  '../views/biz/community/UgcContents.vue'),
      },
      {
        path: '/feeds/:ugcCd?', // UGC컨텐츠 > 피드 목록
        name: 'Feeds',
        props: true,
        component: () => import(/* webpackChunkName: "kr" */  '../views/biz/community/UgcContents.vue'),
      },
      {
        path: '/best-talks', // UGC컨텐츠 > 톡톡 목록(베스트 목록용)
        name: 'BestTalks',
        props: true,
        component: () => import(/* webpackChunkName: "kr" */  '../views/biz/community/UgcContents.vue'),
      },
      {
        path: '/ugc/:ugcCd?', // UGC 상세
        name: 'UgcDetail',
        props: true,
        component: () => import(/* webpackChunkName: "kr" */  '../views/biz/community/UgcDetail.vue'),
      },
      {
        path: '/raffles', // 래플 메인
        name: 'Raffles',
        props: true,
        component: () => import(/* webpackChunkName: "kr" */  '../views/biz/raffle/Raffles.vue'),
      },
      {
        path: '/raffle/:raffleProductCd', // 래플 상세
        name: 'Raffle',
        props: true,
        component: () => import(/* webpackChunkName: "kr" */  '../views/biz/raffle/Raffle.vue'),
      },
      {
        path: '/mypage/tickets', // 내응모권
        name: 'MyTickets',
        component: () => import(/* webpackChunkName: "kr" */  '../views/biz/raffle/MyTickets.vue'),
      },
      {
        path: '/publ/template1', // 퍼블 템플릿
        name: 'Template1',
        component: () => import(/* webpackChunkName: "others" */  '../views/templates/template1.vue'),
      },
      {
        path: '/publ/template2', // 퍼블 템플릿
        name: 'Template2',
        component: () => import(/* webpackChunkName: "others" */  '../views/templates/template2.vue'),
      },
      {
        path: '/publ/template3', // 퍼블 템플릿
        name: 'Template3',
        component: () => import(/* webpackChunkName: "others" */  '../views/templates/template3.vue'),
      },
      {
        path: '/publ/template4', // 퍼블 템플릿
        name: 'Template4',
        component: () => import(/* webpackChunkName: "others" */  '../views/templates/template4.vue'),
      },
      {
        path: '/publ/template5', // 퍼블 템플릿
        name: 'Template5',
        component: () => import(/* webpackChunkName: "others" */  '../views/templates/template5.vue'),
      },
      {
        path: '/publ/template6', // 퍼블 템플릿
        name: 'Template6',
        component: () => import(/* webpackChunkName: "others" */  '../views/templates/template6.vue'),
      },
      {
        path: '/publ/template7', // 퍼블 템플릿
        name: 'Template7',
        component: () => import(/* webpackChunkName: "others" */  '../views/templates/template7.vue'),
      },
      {
        path: '/publ/template8', // 퍼블 템플릿
        name: 'Template8',
        component: () => import(/* webpackChunkName: "others" */  '../views/templates/template8.vue'),
      },
      {
        path: '/publ/index', // 전체 페이지 목록
        name: 'PublIndex',
        meta: { keepAlive: true },
        component: () => import(/* webpackChunkName: "others" */  '../views/templates/index.vue'),
      },
      {
        path: '/publ/modal', // 전체 페이지 목록
        name: 'PublModal',
        meta: { keepAlive: true },
        component: () => import(/* webpackChunkName: "others" */  '../views/templates/Modal.vue'),
      },
      {
        path: '/mypage/withdrawal', // 회원 탈퇴
        name: 'Withdrawal',
        meta: { auth: true },
        component: () => import(/* webpackChunkName: "kr" */  '../views/biz-kr/mypage/Withdrawal.vue'),
      },
    ]
  },
  {
    path: '/mypage/inquiry', // 마이페이지>1:1문의
    name: 'Inquiry',
    props: true,
    meta: { auth: true },
    component: () => import(/* webpackChunkName: "others" */  '../views/biz/mypage/Inquiry.vue'),
  },
]